import '../sass/featured-video-block.scss';
import './featured-video-block';
